import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取首页轮播图列表 get
 * @param query 分页参数
 * @return request
 * */
export function getBannerList(query) {
    return request({
        url: `${baseURL.businessApi}/banners`,
        method: 'get',
        params: query
    })
}

/**
 * 增加首页轮播图 post
 * @param data 增加的数据
 * @return request
 * */
export function addBanner(data) {
    return request({
        url: `${baseURL.businessApi}/banners`,
        method: 'post',
        data: data
    })
}

/**
 * 删除首页轮播图  delete
 * @param id 首页轮播图id
 * @return request
 * */
export function deleteBanner(id) {
    return request({
        url: `${baseURL.businessApi}/banners/${id}`,
        method: 'delete'
    })
}

/***
 * 修改首页轮播图 Post
 * @param id 要修改的首页轮播图id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateBanner(id, data) {
    return request({
        url: `${baseURL.businessApi}/banners/${id}`,
        method: 'post',
        data: data
    })
}